export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function transformICDRecursive(data) {
  return Object.entries(data).map(([key, value]) => {
    const label = value.description
      ? `${key} - ${value.description}`
      : `${key}: ${value}`;

    const node = {
      id: key,
      label,
      description: value.description,
    };

    if (value.subcategory) {
      node.children = transformICDRecursive(value.subcategory);
    } else if (value.codes) {
      node.children = Object.entries(value.codes).map(([code, desc]) => ({
        id: code,
        label: `${code}: ${desc}`,
        description: desc,
      }));
    }

    return node;
  });
}
